export var rgba = function (hexValue, alpha) {
    var hex = hexValue;
    if (hex.substring(0, 1) === '#') {
        hex = hex.substring(1);
    }
    var rChannel = parseInt(hex.substring(0, 2), 16);
    var gChannel = parseInt(hex.substring(2, 4), 16);
    var bChannel = parseInt(hex.substring(4), 16);
    return "rgba(".concat(rChannel, ", ").concat(gChannel, ", ").concat(bChannel, ", ").concat(alpha, ")");
};
export var rtlNoFlip = function (styleValue) { return "".concat(styleValue, " /* @noflip */"); };
//# sourceMappingURL=utilities.js.map